import {
    chakra, Flex
} from '@chakra-ui/react';

export const ModalOverlayBackground = chakra(Flex, {
    label: 'ModalOverlayBackground',
    baseStyle: {
        justifyContent: 'center',
        alignItems: 'center',
        bgColor: 'rgba(0, 0, 0, 0.7)',
        position: 'fixed',
        top: '0',
        left: '0',
        zIndex: '1004',
        h: '100vh',
        w: '100vw'
    }
});
